'use client'

import { trackEvent } from '@/lib/analytics'
import type { AnalyticsEvent } from '@/lib/analytics'
import { useEffect } from 'react'

/**
 * Fires an analytics event once on component mount.
 * Render inside a Server Component to trigger page-level view events.
 */
const TrackOnMount = ({ event }: { event: AnalyticsEvent }) => {
  // biome-ignore lint/correctness/useExhaustiveDependencies: intentionally fires once on mount
  useEffect(() => {
    trackEvent(event)
  }, [])

  return null
}

export default TrackOnMount
